















import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';

import JobWorkerOfferStatus from '@/models/JobWorkerOffers/JobWorkerOfferStatus';


@Component({
  name: 'JobWorkerOfferStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: JobWorkerOfferStatus;

	get pending() {
		return this.hasStatus(JobWorkerOfferStatus.Pending);
	}

	get sentToContact() {
		return this.hasStatus(JobWorkerOfferStatus.SentToContact);
	}

	get contactDeclined() {
		return this.hasStatus(JobWorkerOfferStatus.ContactDeclined);
	}

	get contactConfirmed() {
		return this.hasStatus(JobWorkerOfferStatus.ContactConfirmed);
	}

	get sentToWorker() {
		return this.hasStatus(JobWorkerOfferStatus.SentToWorker);
	}

	get workerDeclined() {
		return this.hasStatus(JobWorkerOfferStatus.WorkerDeclined);
	}

	get workerAccepted() {
		return this.hasStatus(JobWorkerOfferStatus.WorkerAccepted);
	}

	get placed() {
		return this.hasStatus(JobWorkerOfferStatus.Placed);
	}

	get cancelled() {
		return this.hasStatus(JobWorkerOfferStatus.Cancelled);
	}

	hasStatus(status: JobWorkerOfferStatus) {
		if (this.status === status) {
			return true
		}
		return false;
	}
}
